import { FC, MouseEvent, useState } from 'react';
import { graphql, useFragment } from 'react-relay';
import { CurrencyProvider } from 'dibs-buyer-layout/exports/CurrencyProvider';
import { PdpSharedRingSizeGuideModalLink } from '../PdpSharedRingSize/PdpSharedRingSizeGuideModalLink';
import { PdpSharedRingSizeGuideModalLazy } from '../PdpSharedRingSize/PdpSharedRingSizeGuideModalLazy';
import { SeoLink } from 'dibs-elements/exports/SeoLink';
import * as tracking from 'dibs-tracking';

import { PdpSharedRingSizeDetail_detailValues$key } from './__generated__/PdpSharedRingSizeDetail_detailValues.graphql';

type Props = {
    isClient: boolean;
    detailValues: PdpSharedRingSizeDetail_detailValues$key | null;
};

const handleClick = (event: MouseEvent<HTMLElement>): void => {
    tracking.trackEvent(
        {
            category: 'product',
            action: 'view ring size click',
            label: 'pdp attribute',
            eventName: 'product_interaction',
            step_interaction_name:
                tracking.stepInteractionConstants.STEP_INTERACTION_VIEW_RING_SIZE_CLICK,
            interaction_type: tracking.interactionTypeConstants.INTERACTION_TYPE_PDP_ATTRIBUTE,
        },
        event
    );
};

export const PdpSharedRingSizeDetail: FC<Props> = ({ detailValues: detailValuesRef, isClient }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const detailValues = useFragment(
        graphql`
            fragment PdpSharedRingSizeDetail_detailValues on PdpDetailValueInterface
            @relay(plural: true) {
                detailKey
                ... on PdpDetailRingSize {
                    browseUrl
                    ringSizes {
                        unit
                        value
                    }
                }
            }
        `,
        detailValuesRef
    );
    const detailValue = detailValues?.[0];
    const browseUrl = detailValue?.browseUrl;

    return (
        <>
            <CurrencyProvider
                render={({ currency }: { currency: string }) => {
                    const ringMeasurementType = currency === 'USD' ? 'US' : 'MM';
                    const ringSizeDisplay = (detailValue?.ringSizes || []).find(
                        size => size?.unit === ringMeasurementType
                    )?.value;

                    if (browseUrl) {
                        const [size, copy] = (ringSizeDisplay || '').split(',');
                        return (
                            <>
                                <SeoLink
                                    linkData={{ path: browseUrl, isLinkable: true }}
                                    onClick={handleClick}
                                >
                                    {size}
                                </SeoLink>
                                {copy ? `, ${copy}` : null}
                            </>
                        );
                    }
                    return <>{ringSizeDisplay}</>;
                }}
            />
            <div>
                <PdpSharedRingSizeGuideModalLink onClick={() => setModalOpen(true)} />
                {isClient && (
                    <PdpSharedRingSizeGuideModalLazy
                        isOpen={modalOpen}
                        onClose={() => setModalOpen(false)}
                    />
                )}
            </div>
        </>
    );
};
